import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import UploadPODComponent from 'src/components/VehicleTrackingLocationShare/UploadPODComponent';
import { createPODAttachmentsForVehicleTracking } from 'src/redux/Actions/Vehicle';
import 'src/style/invoice.css';

export default function VehicleTrackingLocationSharePODUploadModal({
  show,
  onHide,
  vehicleTrackingNumber,
  themeColor,
  onUploaded,
}) {
  const dispatch = useDispatch();
  const [uploading, setUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [pendingFiles, setPendingFiles] = useState([]);

  const handleClose = () => {
    setUploading(false);
    setErrorMessage('');
    setPendingFiles([]);
    onHide();
  };

  const handleFileUpload = async (files) => {
    try {
      setUploading(true);
      setErrorMessage('');

      const formData = new FormData();
      files.forEach((file) => formData.append('file', file));
      formData.append('vehicle_tracking_number', vehicleTrackingNumber);

      await dispatch(createPODAttachmentsForVehicleTracking(formData));
      await onUploaded();
      handleClose();
    } catch (error) {
      setErrorMessage(
        error.response?.data?.error ||
          error.message ||
          'Failed to upload POD. Please try again.',
      );
    } finally {
      setUploading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="py-2">
        <Modal.Title className="text-lg text-semi-bold">Upload POD</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="div-flex-column div-align-center rg-20 container-padding-20">
          {errorMessage && (
            <div className="alert alert-danger py-2 w-100" role="alert">
              {errorMessage}
            </div>
          )}
          <p className="text-md text-grey mb-0 text-center">
            Take a Photo or Upload POD images. You can select multiple files at
            once.
          </p>
          <UploadPODComponent
            onFileUpload={handleFileUpload}
            uploading={uploading}
            onFilesUploaded={setPendingFiles}
            hideUploadButton
            themeColor={themeColor}
          />
          {uploading && (
            <div className="div-flex-column div-align-center rg-10">
              <div className="spinner-border" role="status" />
              <span className="text-sm">Uploading POD...</span>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="div-flex-row div-space-between py-2">
        <button
          className={`vehicle-tracking-detail-add-vehcile-data-btn theme-text-${themeColor} theme-border-color-${themeColor} div-align-center`}
          onClick={handleClose}
        >
          <span className="text-md">Cancel</span>
        </button>
        {pendingFiles.length > 0 && (
          <button
            className={`vehicle-tracking-detail-move-stage-btn theme-background-${themeColor} div-align-center`}
            onClick={() => handleFileUpload(pendingFiles)}
            disabled={uploading}
          >
            <span className="text-md">
              {uploading
                ? 'Uploading...'
                : `Upload ${pendingFiles.length} ${pendingFiles.length === 1 ? 'File' : 'Files'}`}
            </span>
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
